export default __webpack_public_path__ + "static/media/pic1.ba885196.PNG";